import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { authApi, baseApi, blankApi, chartsApi, privateApi, userApi } from 'store/api';
import { adminApi } from 'store/api/private/user-api/admin-api';
import blankReducer from 'store/slices/blank-slice';
import userReducer from 'store/slices/user-slice';

const reducer = combineReducers({
	[authApi.reducerPath]: authApi.reducer,
	[userApi.reducerPath]: userApi.reducer,
	[baseApi.reducerPath]: baseApi.reducer,
	[privateApi.reducerPath]: privateApi.reducer,
	// [blankApi.reducerPath]: blankApi.reducer,
	[adminApi.reducerPath]: adminApi.reducer,
	userState: userReducer,
	blankState: blankReducer,
});

export const setupStore = () => {
	return configureStore({
		reducer,
		devTools: process.env.NODE_ENV === 'development',
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: {
					// Игнорируем экшены, которые возвращают Blob:
					ignoredActions: ['privateApi/executeQuery/fulfilled', 'userApi/executeQuery/fulfilled'],
					ignoredPaths: ['userApi.queries.downloadFile.data', 'privateApi.queries.downloadFile.data'],
				},
			}).concat(
				authApi.middleware,
				userApi.middleware,
				baseApi.middleware,
				privateApi.middleware,
				adminApi.middleware,
			),
	});
};

export type AppState = ReturnType<typeof reducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
